import {connect, useSelector} from "react-redux";
import React, {useMemo, useRef, useState} from "react";
import {
	CAlert,
	CButton,
	CCol,
	CContainer,
	CForm,
	CFormInput,
	CFormSelect,
	CInputGroup,
	CInputGroupText,
	CRow
} from "@coreui/react";

import {DatePicker} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import locale from "antd/es/date-picker/locale/ko_KR";
import {Loading} from "../../../../components/common";
import {AgGridReact} from "ag-grid-react";
import numeral from "numeral";

import * as formatter from "../../../../config/formatter";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";
import * as o2Api from "../../../../api/api";
import {gridColumnAvg, gridColumnSum} from "../../../../config/common";
import {Br, Cut, Line, Printer, render, Row, Text} from "react-thermal-printer";
import {cutStr, getTextLength, lpad, rpad} from "../../../../util/stringUtil";
import {printerActions} from "../../../../redux-store/actions/printer";
import {getStoreWhere} from "../../../../api/api";

const {RangePicker} = DatePicker;
const ProductSales = (props) => {
	const {user} = useSelector((props) => props.account);
	const {printer} = useSelector((props) => props.printer);
	const gridRef = useRef();
	const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);

	const [rowData, setRowData] = useState([]);
	const [error, setError] = useState({
		visible: false,
		message: ""
	});
	const [searchForm, setSearchForm] = useState({
		fromSaleDt: dayjs(), toSaleDt: dayjs(), itemCd: "", itemNm: "", barcode: ""
	});

	const defaultColDef = {
		maxWidth: 100,
		resizable: true,
		sortable: true,
		filter: false,
		autoHeaderHeight: true
	};

	const [columnDefs] = useState([
		{field: "no", headerName: "No", maxWidth: 50, valueGetter: "node.rowIndex + 1"},
		{field: "restProductCd", headerName: "상품코드", maxWidth: 120, cellClass: "static-cell"},
		{field: "barcode", headerName: "바코드", maxWidth: 120},
		{field: "productNm", headerName: "상품명", maxWidth: 200},
		{
			field: "saleQty",
			headerName: "수량",
			maxWidth: 60,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "saleAmt",
			headerName: "총매출액",
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "dcAmt",
			headerName: "할인액",
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "payAmt",
			headerName: "실매출액",
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "0",
			headerName: "선수입금액",
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "수수료",
			headerName: "수수료",
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{
			field: "bagPrice",
			headerName: "봉투",
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		}
	]);

	const createStatTotalRowData = (data) => {
		const api = gridRef.current.api;
		const result = [];
		result.push({
			No: "합계",
			saleQty: gridColumnSum(data, 'saleQty'),
			saleAmt: gridColumnSum(data, 'saleAmt'),
			dcAmt: gridColumnSum(data, 'dcAmt'),
			payAmt: gridColumnSum(data, 'payAmt'),
			bagPrice: gridColumnSum(data, 'bagPrice'),
		});
		api.setPinnedBottomRowData(result);
	};

	const search = () => {
		setError({visible: false, message: ""});

		const {cmpCd, brandCd, storeCd, cornerCd} = searchForm;
		if (brandCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 휴게소는 반드시 선택하셔야 합니다."
			});
			return;
		}

		if (storeCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 매장은 반드시 선택하셔야 합니다."
			});
			return;
		}

		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			cornerCd: cornerCd,
			itemCd: searchForm.itemCd,
			itemNm: searchForm.itemNm,
			barcode: searchForm.barcode,
			fromSaleDt: searchForm.fromSaleDt.format("YYYYMMDD"),
			toSaleDt: searchForm.toSaleDt.format("YYYYMMDD")
		};
		console.log(">>> getPeriodProductSale :: ", params);

		props.setLoading(true);
		o2Api.getPeriodProductSale(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			if (responseCode === "200") {
				console.log("stat : ", responseBody);

				props.setLoading(false);
				setRowData(responseBody);
				createStatTotalRowData(responseBody);

			}
		})
			.catch((e) => {
				props.setLoading(false);
				alert("조회 중 오류가 발생했습니다.\n" + e.message);
			})
		;
	};

	const onCellClicked = (params) => {
		console.log(params);
	};

	async function getStore() {
		const {cmpCd, brandCd, storeCd} = searchForm;
		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			manageDiv: "0",
			userId: user.userId
		};

		const {data: result} = await getStoreWhere(params);
		const {responseBody, responseCode, responseMessage} = result;
		if (responseCode === "200") {
			if (responseBody != null) {
				return responseBody[0];
			} else return null;
		}
	}

	const handleSelect = (code, value) => {
		if (value === "C") {
			setSearchForm((state) => ({
				...state,
				cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
			}));
		} else if (value === "B") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: code, storeCd: "", cornerCd: ""
			}));
		} else if (value === "S") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: code, cornerCd: ""
			}));
		} else if (value === "O") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: state.storeCd, cornerCd: code
			}));
		}
	}

	const print = async () => {
		if (confirm("출력하시겠습니까?")) {
			if (rowData.length === 0) {
				alert("출력할 데이터가 없습니다.");
				return;
			}

			if ("serial" in navigator) {
				const filters = []

				// 시리얼포트 선택
				try {
					console.log("### printerPort :: ", printer);
					let port;
					if (printer === null || printer === undefined) {
						port = await navigator.serial.requestPort({filters});
						await port.open({baudRate: 9600})
						// 포트 오픈 후에 해당 값을 담아둔다
						props.setPrinterPort(port);
					} else {
						port = printer;
					}

					props.setLoading(true);
					// 영수증 출력을 위한 점포정보 가져오기
					const storeInfo = await getStore();
					console.log("### storeInfo :: ", storeInfo);

					let cornerCd = "";
					let subTotalSaleQty = 0;
					let subTotalPayAmt = 0;
					let totalSaleQty = 0;
					let totalPayAmt = 0;
					const receipt = (
						<Printer type={"epson"} width={42} characterSet={"korea"}>
							<Text align={"center"} bold={true} size={{width: 2, height: 1}}>상품별 매출현황</Text>
							<Br/>
							<Row left={<Text>{storeInfo.storeNm}</Text>} right={<Text>T:{storeInfo.telNo}</Text>}/>
							<Text>대표 : {storeInfo.ownerNm}</Text>
							<Text>{storeInfo.addr1}</Text>
							<Text>조회기간 : {searchForm.fromSaleDt.format("YYYYMMDD")} ~ {searchForm.toSaleDt.format("YYYYMMDD")}</Text>
							<Line character={"="}/>
							<Text>{"상품                        수량      매출"}</Text>
							<Line/>
							{rowData.map((item, idx) => {
								const changeCorner = cornerCd !== item.cornerCd;
								cornerCd = item.cornerCd;
								// 상품명 한글 체크, 자르기
								let productNm = item.productNm;
								if (getTextLength(productNm) > 24) productNm = rpad(cutStr(productNm, 0, 24), 24, " ");
								else productNm = rpad(productNm, 24, " ");
								const saleQty = lpad(numeral(item.saleQty).format('0,0'), 6, " ");
								subTotalSaleQty += item.saleQty;
								totalSaleQty += item.saleQty;
								const payAmt = lpad(numeral(item.payAmt).format('0,0'), 12, " ");
								subTotalPayAmt += item.payAmt;
								totalPayAmt += item.payAmt;

								// 중간집계
								let isSubTotal = false;
								let isTotal = false;
								let SubTotalText;
								let TotalText;
								if (rowData.length > idx + 1) {
									const nextCornerCd = rowData[idx + 1].cornerCd;
									if (nextCornerCd !== cornerCd) {
										isSubTotal = true;
										const productNm = rpad("SUB TOTAL", 24, " ");
										const saleQty = lpad(numeral(subTotalSaleQty).format('0,0'), 6, " ");
										const payAmt = lpad(numeral(subTotalPayAmt).format('0,0'), 12, " ");
										SubTotalText = <Text>{productNm}{saleQty}{payAmt}</Text>;
										subTotalSaleQty = 0;
										subTotalPayAmt = 0;
									}
								}

								if (rowData.length === idx + 1) {
									isSubTotal = true;
									const productNm = rpad("SUB TOTAL", 24, " ");
									const saleQty = lpad(numeral(subTotalSaleQty).format('0,0'), 6, " ");
									const payAmt = lpad(numeral(subTotalPayAmt).format('0,0'), 12, " ");
									SubTotalText = <Text>{productNm}{saleQty}{payAmt}</Text>;

									isTotal = true;
									const sTotal = rpad("합    계", 24, " ");
									const sTotalSaleQty = lpad(numeral(totalSaleQty).format('0,0'), 6, " ");
									const sTotalPayAmt = lpad(numeral(totalPayAmt).format('0,0'), 12, " ");
									TotalText = <Text>{sTotal}{sTotalSaleQty}{sTotalPayAmt}</Text>
								}

								return (
									<div key={idx}>
										{changeCorner &&
										<Text bold size={{width: 1, height: 2}}>[{item.cornerCd}] {item.cornerNm}</Text>
										}
										<Text key={idx}>{productNm}{saleQty}{payAmt}</Text>
										{isSubTotal &&
										<div>
											<Text>{"                        ------------------"}</Text>
											{SubTotalText}
											<Line character={"-"} />
										</div>
										}
										{isTotal && TotalText
										}
									</div>
								)
							})}
							<Line character={"="}/>
							<Br/>
							<Row left={"출력일자"} right={dayjs().format("YYYY-MM-DD HH:mm:ss")}/>
							<Br/>
							<Cut/>
						</Printer>
					)
					const data: Uint8Array = await render(receipt);

					const writer = port.writable.getWriter();
					if (writer != null) {
						await writer.write(data);
						writer.releaseLock();

						// await port.close();
						props.setLoading(false);
					}
				} catch (ex) {
					props.setLoading(false);
					alert("Exception :: " + ex.message);
				}
			} else {
				console.log("serial 미지원");
				alert("브라우저에서 SERIAL 출력을 지원하지 않습니다.\n다른 브라우저를 이용해 주세요.");
			}
		}
	}

	return (
		<>
			<div style={containerStyle}>
				{error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
				<div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
					<h5>상품별 매출현황</h5>
				</div>
				<StoreCornerListWhere type={"O"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
				<div className={"row row-cols-lg-auto g-1 m-0 align-items-center"}>
					<CCol xs={12} md={6}>
						<CInputGroup size="sm">
							<CInputGroupText style={{width: 80}}>조회일자</CInputGroupText>
							<CInputGroupText style={{background: "white", height: 35}}>
								<RangePicker bordered={false}
											 separator={"~"}
											 placeholder={""}
											 locale={locale}
											 value={[searchForm.fromSaleDt, searchForm.toSaleDt]}
											 onChange={(dayjs, dateString) => {
												 setSearchForm((state) => ({
													 ...state, fromSaleDt: dayjs[0], toSaleDt: dayjs[1]
												 }));
											 }}/>
							</CInputGroupText>
						</CInputGroup>
					</CCol>
					<CCol xs={12} md={6}>
						<CInputGroup size="sm" style={{height: 35}}>
							<CInputGroupText style={{width: 80}}>상품코드</CInputGroupText>
							<CFormInput id="itemCd"
										onChange={(e) => {
											setSearchForm((state) => ({
												...state,
												itemCd: e.target.value
											}));
										}}/>
						</CInputGroup>
					</CCol>
					<CCol xs={12} md={6}>
						<CInputGroup size="sm" style={{height: 35}}>
							<CInputGroupText style={{width: 80}}>상품명</CInputGroupText>
							<CFormInput id="itemNm"
										onChange={(e) => {
											setSearchForm((state) => ({
												...state,
												itemNm: e.target.value
											}));
										}}/>
						</CInputGroup>
					</CCol>
					<CCol xs={12} md={6}>
						<CInputGroup size="sm" style={{height: 35}}>
							<CInputGroupText style={{width: 80}}>바코드</CInputGroupText>
							<CFormInput id="barcode"
										onChange={(e) => {
											setSearchForm((state) => ({
												...state,
												barcode: e.target.value
											}));
										}}/>
						</CInputGroup>
					</CCol>
					<div className={"d-grid d-lg-flex gap-1"}>
						<CButton style={{minWidth: 50, height: 35}} size={"sm"} color="primary" onClick={print}>출력</CButton>
						<CButton style={{minWidth: 50, height: 35}} size={"sm"} color="primary" onClick={search}>조회</CButton>
					</div>
				</div>
				<div className="ag-theme-alpine" style={{width: "100%", height: 500, marginTop: 10}}>
					<AgGridReact
						ref={gridRef}
						onCellClicked={onCellClicked}
						rowMultiSelectWithClick={true}
						rowData={rowData}
						animateRows={true}
						headerHeight={30}
						rowHeight={30}
						defaultColDef={defaultColDef}
						columnDefs={columnDefs}>
					</AgGridReact>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const {account, store, selected} = state;
	return {
		account, store, selected
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setPrinterPort: (printer) => {
			dispatch(printerActions.setPrinterPort(printer));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductSales);
